import React from "react";
import { useI18n } from "@/lib/i18n";

export default function About() {
  const { t } = useI18n();
  const cards = [
    { title: t("about.sourcing_title"), body: t("about.sourcing_body"), img: "https://images.pexels.com/photos/31890551/pexels-photo-31890551.jpeg" },
    { title: t("about.roast_title"), body: t("about.roast_body"), img: "https://images.unsplash.com/photo-1524350876685-274059332603?w=1200" },
    { title: t("about.brew_title"), body: t("about.brew_body"), img: "https://images.unsplash.com/photo-1770565356338-7bf46fabe8c5?w=1200" },
  ];
  return (
    <div>
      <section className="pt-20 lg:pt-28 max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-3">
          <p className="label-eyebrow text-[hsl(var(--sk-primary))]">{t("about.eyebrow")}</p>
        </div>
        <div className="lg:col-span-9">
          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter leading-[0.95] max-w-3xl">{t("about.title")}</h1>
          <p className="mt-10 text-lg text-[hsl(var(--sk-muted-fg))] max-w-2xl leading-relaxed">{t("about.story")}</p>
        </div>
      </section>

      <section className="mt-24 max-w-7xl mx-auto px-6 lg:px-10 space-y-24">
        {cards.map((c, i) => (
          <div key={c.title} className={`grid lg:grid-cols-12 gap-10 items-center ${i % 2 ? "" : "lg:[&>*:first-child]:order-2"}`}>
            <div className="lg:col-span-7 aspect-[4/3] rounded-2xl overflow-hidden">
              <img src={c.img} alt="" className="w-full h-full object-cover" />
            </div>
            <div className="lg:col-span-5">
              <p className="label-eyebrow text-[hsl(var(--sk-accent))]">0{i + 1}</p>
              <h3 className="mt-4 font-display text-3xl sm:text-4xl tracking-tight">{c.title}</h3>
              <p className="mt-6 text-[hsl(var(--sk-muted-fg))] leading-relaxed">{c.body}</p>
            </div>
          </div>
        ))}
      </section>
      <div className="h-32" />
    </div>
  );
}
